import { fetch } from "../utils/fetch";
import { casaApiUrl } from "configs/casa-api";
import { saveAs } from "file-saver";
import queryString from "query-string";
import { toPublishObject } from "./publish-format.service";
import ruleService from "./rules-service";
import _ from "lodash";

function getCampaignsCount() {
  return fetch(`${casaApiUrl}/users/published-campaigns/total-count`, {
    credentials: "include",
  })
    .then((r) => r.json())
    .then((r) => r.count || 0);
}

function getCustomerReach() {
  return fetch(`${casaApiUrl}/users/published-campaigns/customer-reach`, {
    credentials: "include",
  })
    .then((r) => r.json())
    .then((r) => r.count || 0);
}

function getSentCount() {
  return fetch(`${casaApiUrl}/users/published-campaigns/sent-count`, {
    credentials: "include",
  })
    .then((r) => r.json())
    .then((r) => r.count || 0);
}

function getViewPercentage() {
  return fetch(
    `${casaApiUrl}/users/published-campaigns/response-percentage/view`,
    {
      credentials: "include",
    }
  ).then((r) => r.json());
}

function getBuyPercentage() {
  return fetch(
    `${casaApiUrl}/users/published-campaigns/response-percentage/buy`,
    {
      credentials: "include",
    }
  ).then((r) => r.json());
}

function getCampaignsData(filter) {
  return fetch(`${casaApiUrl}/users/published-campaigns/campaigns-data`, {
    credentials: "include",
    method: "POST",
    body: JSON.stringify({
      filter,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((r) => r.json());
}

function getReportViewsMaster() {
  return fetch(
    `${casaApiUrl}/users/published-campaigns/campaigns-data/reports`,
    {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }
  ).then((r) => r.json());
}

function getFbLeadCampaignStats() {
  return fetch(`${casaApiUrl}/users/facebook/campaign-data`, {
    credentials: "include",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((r) => r.json());
}

function getReportForCampaign(id, view, stores, page) {
  let query = queryString.stringify(
    { stores: stores, page: page },
    { arrayFormat: "bracket" }
  );
  return fetch(
    `${casaApiUrl}/users/published-campaigns/campaigns-data/${id}/report/${view}?${query}`,
    {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).then((r) => r.json());
}

function getCountReportForCampaign(id) {
  return fetch(
    `${casaApiUrl}/users/published-campaigns/campaigns-data/${id}/count-report`,
    {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).then((r) => r.json());
}

function exportCampaignReport(id, name, view, stores) {
  let query = queryString.stringify(
    { stores: stores },
    { arrayFormat: "bracket" }
  );
  return fetch(
    `${casaApiUrl}/users/published-campaigns/campaigns-data/${id}/report/${view}/export?${query}`,
    {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "text/csv",
      },
      responseType: "blob",
    }
  )
    .then((res) => res.blob())
    .then((blob) => saveAs(blob, `${name}.csv`));
}

function getStores() {
  return fetch(`${casaApiUrl}/users/tenant/stores`, {
    credentials: "include",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((r) => r.json());
}

function getCampaignDetails(filters) {
  let query = queryString.stringify(
    {
      fromDate: filters.startDate.toISOString(),
      toDate: filters.endDate.toISOString(),
    },
    { arrayFormat: "bracket" }
  );
  return fetch(`${casaApiUrl}/users/campaigns?${query}`, {
    credentials: "include",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((r) => r.json());
}

function getBatchRuleSource() {
  return fetch(`${casaApiUrl}/users/batch-rule-source`, {
    credentials: "include",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((r) => r.json());
}

function saveOrUpdateCampaign(campaignInfo) {
  return saveRule(campaignInfo.rule).then((res) => {
    return getAllRules().then((rules) => {
      let createdRule = rules.find((x) => x.id === res.id);
      // raj batch rule
      // let createdRule = rules.find(x => x.id === 'AXBR1M1k8QtZZBnIWZIV')
      campaignInfo.rule = createdRule;
      let campaign = {
        campaign: JSON.stringify(campaignInfo),
      };
      return campaignSave(campaign).then((r) => {
        return publishCampaign(r).then((res) => {
          if (!_.isEmpty(res.id)) {
            return triggerCampaignByCampaignId(res.id);
          }
          return res;
        });
      });
    });
  });
}

function createCampaign(campaignInfo) {
  return ruleService.createRule(campaignInfo.rule).then((res) => {
    return getAllRules().then((rules) => {
      campaignInfo.rule = rules.find((x) => x.id === res.id);
      let campaign = {
        campaign: JSON.stringify(campaignInfo),
      };
      return campaignSave(campaign).then((r) => {
        return publishCampaign(r).then((res) => {
          return res;
        });
      });
    });
  });
}

function triggerCampaignByCampaignId(campaignId) {
  let triggerInfo = { isBatch: true };
  return fetch(`${casaApiUrl}/users/rule-jobs/${campaignId}`, {
    credentials: "include",
    method: "POST",
    body: JSON.stringify(triggerInfo),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((r) => r.json());
}

function campaignSave(campaign) {
  return fetch(`${casaApiUrl}/users/campaigns`, {
    credentials: "include",
    method: "POST",
    body: JSON.stringify(campaign),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
}

function publishCampaign(campaignInfo) {
  // console.log('--test before->>', campaignInfo)
  let campaignDetails = toPublishObject(campaignInfo);
  // console.log('--test after->>', campaignDetails)
  return fetch(`${casaApiUrl}/users/campaigns/publish`, {
    credentials: "include",
    method: "POST",
    body: JSON.stringify(campaignDetails),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
}

function getAllRules() {
  return fetch(`${casaApiUrl}/users/rule-configs`, {
    credentials: "include",
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((res) => res.json());
}

function saveRule(ruleInfo) {
  return fetch(`${casaApiUrl}/users/rule-configs`, {
    credentials: "include",
    method: "POST",
    body: JSON.stringify(ruleInfo.rules),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((res) => res.json());
}

function getAllOfferTags(businessUnitId) {
  return fetch(
    `${casaApiUrl}/users/offers/tags/businessUnit/${businessUnitId}`,
    {
      credentials: "include",
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
  ).then((res) => res.json());
}

function downloadCampaignReport(campaignId) {
  return fetch(
    `${casaApiUrl}/users/published-campaigns/campaigns-data/${campaignId}/download`,
    {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  ).then((r) => r.json());
}

export default {
  getCampaignsCount,
  getFbLeadCampaignStats,
  getCustomerReach,
  getSentCount,
  getViewPercentage,
  getBuyPercentage,
  getCampaignsData,
  getReportViewsMaster,
  getReportForCampaign,
  exportCampaignReport,
  getStores,
  getCountReportForCampaign,
  getCampaignDetails,
  getBatchRuleSource,
  saveOrUpdateCampaign,
  getAllOfferTags,
  createCampaign,
  downloadCampaignReport
};



// WEBPACK FOOTER //
// ./src/services/campaigns-service.js